module.exports = __webpack_public_path__ + "fonts/LidlFontPro-BookItalic.woff2";